__turbopack_context__.v({
  "cnfEnter": "CustomNumberFlow-module__wa2qVW__cnfEnter",
  "digit": "CustomNumberFlow-module__wa2qVW__digit",
  "entering": "CustomNumberFlow-module__wa2qVW__entering",
  "respectMotion": "CustomNumberFlow-module__wa2qVW__respectMotion",
  "srOnly": "CustomNumberFlow-module__wa2qVW__srOnly",
  "stack": "CustomNumberFlow-module__wa2qVW__stack",
  "symbol": "CustomNumberFlow-module__wa2qVW__symbol",
  "wrapper": "CustomNumberFlow-module__wa2qVW__wrapper",
});
